import React from 'react'
import location from "../images/svg/location.svg"
import phone from "../images/svg/phone.svg"
import email from "../images/svg/email.svg"
import Button from "../components/Button"
import Content from '../components/Content'
import Footer from '../components/Footer'
import Nav from '../components/Nav'
const ContactUs = () => {
  return (
    <div>
         <div className="h-3/4 bg bg-cover">
        <div className="h-full z-10 overlay">
            <Nav/>
          <div className="container landing mx-auto z-10 text-center text-white">
            <p className="text-4xl">CONTACT US</p>
          </div>
          </div>
          </div>
            
<div className="container mx-auto pt-10 grid md:grid-cols-2 grid-cols-1 md:grid-flow-col grid-flow-row gap-10">
    <div className="col-span-2">
        <Content isColor={true} title="CONTACT US" subtitle="Contact Information" content="We are always here to help you. you don't hesitate to
contact with us"/>
<div className="container md:w-1/2 w-full grid grid-cols-2 grid-rows-3 text-left gap-5">
    <div className="relative p-5 "><img className="absolute top-4 right-0" src={location} width="30px" height="30px" alt="bg"/></div>
    <div><p className="text-xl font-semibold">Address</p>
<p>Hotel sarvoday & restaurant Kankrol Service Road,
Nr.Sahkari Jin Char Rasta, Opp. Medistar Hospital,
himmatnagar, Gujarat 383001, India</p></div>
<div className="relative p-5 "><img className="absolute top-4 right-0 " src={email} alt="bg" width="30px" height="30px" /></div>
<div><p className="text-xl font-semibold">Email Address</p>
<p>shrilaxmichem@gmail.com</p>
</div>
<div className="relative p-5 "><img className="absolute top-4 right-0" src={phone} alt="bg" width="30px" height="30px" /></div>
<div>
<p className=" text-xl font-semibold">Call now</p>
<p>+91 99257 22555</p>

<p>+91 2772 240 933</p>
<p>+91 99139 22555</p></div>
</div>
    </div>
    <div className="max-w-5xl mx-auto  sm:px-6 lg:px-8">
        <div className="bg-[#fff4f4] w-full shadow rounded p-8 sm:p-12 mt-15">
            <p className="text-3xl font-bold leading-7 text-center text-black">Get In Touch</p>
            <form action="" method="post">
                <div className="md:flex items-center mt-12">
                    <div className="w-full md:w-1/2 flex flex-col">
  
                        <input type="text" placeholder="Name" className="leading-none text-gray-50 p-4 focus:outline-none focus:border-[#d2a960] mt-4 border-0 bg-white " />
                    </div>
                    <div className="w-full md:w-1/2 flex flex-col md:ml-6 md:mt-0 mt-4">
                        
                        <input type="email" placeholder="Email" className="leading-none text-gray-50 p-4 focus:outline-none focus:border-[#d2a960] mt-4 border-0 bg-white"/>
                    </div>
                    
                </div>
             <div className="md:flex items-center mt-3">
                    <div className="w-full md:w-1/2 flex flex-col">
  
                        <input type="number" placeholder="Phone Number" className="leading-none text-gray-50 p-4 focus:outline-none focus:border-[#d2a960] mt-4 border-0 bg-white " />
                    </div>
                    <div className="w-full md:w-1/2 flex flex-col md:ml-6 md:mt-0 mt-4">
                        
                        <input type="text" placeholder="Your Website" className="leading-none text-gray-50 p-4 focus:outline-none focus:border-[#d2a960] mt-4 border-0 bg-white"/>
                    </div>
                    
                </div>
             
                <div>
                    <div className="w-full flex flex-col mt-8">
             
                        <textarea type="text" placeholder="Your message here" className="h-40 text-base leading-none text-gray-50 p-3 focus:outline-none focus:border-[#d2a960] mt-4 bg-white border-0"></textarea>
                    </div>
                </div>
                <div className="flex items-center justify-center w-full pt-6">
                    <Button isColour={true} label='SUBMIT'/>
                </div>
            </form>
        </div>
    </div>
    </div>
    
    <Footer/></div>
    
  )
}

export default ContactUs